import { render, staticRenderFns } from "./gestionDossiers.vue?vue&type=template&id=5f57e08f&scoped=true"
import script from "./gestionDossiers.vue?vue&type=script&lang=js"
export * from "./gestionDossiers.vue?vue&type=script&lang=js"
import style0 from "./gestionDossiers.vue?vue&type=style&index=0&id=5f57e08f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57e08f",
  null
  
)

export default component.exports